/* eslint-disable indent */
export const validations = {
    login: {
        email: [
            {
                regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                message: 'Please Enter a valid Email.'
            }
        ]
    },

   meta: {
        iconUrl: [
            {
                regex: /^https?:\/\/(?:[a-z0-9-]+\.)+[a-z]{2,6}(?:\/[^/#?]+)+\.(?:jpe?g|gif|png|ico|svg)$/,
                message: 'Please Enter a valid icon url format. (jpeg, gif, png)'
            }
        ]
   },

    downloadable: {
        versionNumber: [
            {
                regex: /^(\d+\.)?(\d+\.)?(\*|\d+)$/,
                message: 'Please Enter a valid version number format'
            }
        ]
    }
}
